import { ChangeDetectorRef, Component, EventEmitter, Input, IterableDiffers, Output, TemplateRef } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { Paginator } from "@sharedV11/classes/paginator/paginator";
import { BasicList, DualListComponent } from "angular-dual-listbox";

@Component({
  selector: "customan-dual-list",
  templateUrl: "./customan-dual-list.component.html",
  styleUrls: ["./customan-dual-list.component.scss"],
})
export class CustomanDualListComponent extends DualListComponent {
  @Input() listLabel: string;
  @Input() copyList: any;
  @Input() filter: boolean;
  @Input() withPagination: boolean = false;
  @Input() paginator: Paginator;
  @Output() pageEvent: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output() emitMovedCentro: EventEmitter<void> = new EventEmitter<void>();
  @Output() emitConfirmedItem: EventEmitter<any> = new EventEmitter<any>();
  @Input() totalLength: number = 0;
  @Input() isRightMultiSelection: boolean = true;
  @Input() showOrderInput: boolean = false;
  @Input() orderField: string = "ordenCategoria";
  @Input() actionTemplate: TemplateRef<any>;

  listanmenu;

  constructor(
    differs: IterableDiffers,
    private cdr: ChangeDetectorRef
  ) {
    super(differs);
  }

  ngDoCheck(): void {
    super.ngDoCheck();
    this.cdr.markForCheck();
  }

  /** Lista izquierda sin los ítems que ya están en la derecha (evita duplicados cuando source incluye ítems preasignados). */
  get availableSiftLeft(): any[] {
    const sift = this.available?.sift ?? [];
    const list = this.confirmed?.list ?? [];
    if (list.length === 0) return sift;
    const norm = (v: any) => v != null && v !== '' ? String(v) : null;
    const confirmedIds = new Set(
      list.map((c: any) => norm(c?._id)).filter((id: string | null) => id != null)
    );
    return sift.filter((item: any) => {
      const id = norm(item?._id);
      return id == null || !confirmedIds.has(id);
    });
  }

  verlista(nombre) {
    event.stopPropagation();
  }

  async emitPageEvent(event: PageEvent) {
    await this.pageEvent.emit(event);
  }

  executeCopy(text) {
    var input = document.createElement("textarea");
    document.body.appendChild(input);
    input.value = text;
    input.focus();
    input.select();
    document.execCommand("Copy");
    input.remove();
  }

  onClickConfirdemItem(confimedPick: any[], item: any, confirmed: BasicList): void {
    this.selectItem(confimedPick, item);
    
    if (!this.isRightMultiSelection) {
      confirmed.pick = confirmed.pick?.length ? confirmed.pick.filter((pickItem) => pickItem?._id === item?._id) : [];
      this.emitConfirmedItem.emit(item);
    }

    if (!this.isRightMultiSelection && !confirmed?.pick.length) {
      confirmed.pick = [item];
    }
  }

  clipboard(url, params) {
    //navigator.clipboard.writeText(url+params); // posibles problemas con seguridad, es para copiar cosas grandes y binarias.

    this.executeCopy(url + params);
    /*
        var r = document.createRange();
        document.getElementById("myclipboard").innerHTML= url+params;
        r.selectNode(document.getElementById("myclipboard"));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(r);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        */

    /*     if (document.selection) {
        var range = document.body.createTextRange();
        range.moveToElementText(document.getElementById(containerid));
        range.select().createTextRange();
        document.execCommand("copy");
        } else if (window.getSelection) {
        var range = document.createRange();
        range.selectNode(document.getElementById(containerid));
        window.getSelection().addRange(range);
        document.execCommand("copy");
        alert("Text has been copied, now paste in the text-area")
        } */

    /*         var urllink = document.querySelector('.laurl');
        var range = document.createRange();
        range.selectNode(urllink);
        window.getSelection().addRange(range);
    
        try {
        // Now that we've selected the anchor text, execute the copy command
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        } catch(err) {
        } */
  }

  onOrderChange(item: any, value: any) {
    if (!item) {
      return;
    }

    const ordenNormalizado = this.normalizeOrder(value);
    const destino = this.findDestinationItem(item);

    if (destino && typeof destino === "object") {
      destino[this.orderField] = ordenNormalizado;
    }
  }

  private normalizeOrder(value: any): number {
    const numero = Number(value);

    if (Number.isFinite(numero) && numero >= 0) {
      return Math.floor(numero);
    }

    return 0;
  }

  getOrderValue(item: any): number {
    const destino = this.findDestinationItem(item);

    if (!destino || typeof destino !== "object") {
      return 0;
    }

    if (
      destino[this.orderField] === undefined ||
      destino[this.orderField] === null ||
      destino[this.orderField] === ""
    ) {
      destino[this.orderField] = 0;
    }

    return this.normalizeOrder(destino[this.orderField]);
  }

  private findDestinationItem(item: any): any {
    const itemId = this.resolveItemId(item);

    if (itemId === undefined || !this.destination || !Array.isArray(this.destination)) {
      return null;
    }

    const encontrado = this.destination.find((dest) => {
      if (dest && typeof dest === "object") {
        const destId = this.resolveItemId(dest);
        return destId === itemId;
      }

      return dest === itemId;
    });

    return encontrado || null;
  }

  private resolveItemId(item: any): any {
    if (!item) {
      return undefined;
    }

    if (item._id !== undefined) {
      return item._id;
    }

    if (this.key && item[this.key] !== undefined) {
      return item[this.key];
    }

    if (item.pkId !== undefined) {
      return item.pkId;
    }

    return item;
  }

  stopOrderInputEvent(event: Event) {
    event.stopPropagation();
  }

  /**
   * Altura mínima adaptativa e sincronizada entre as duas listas.
   * - Calcula uma altura desejada em função da quantidade de itens (esq./dir.), tipo: linhas * alturaLinha.
   * - Garante um mínimo agradável (120px) e nunca passa do max-height configurado (this.height).
   * Assim, nenhum dos lados fica menor que o outro e o grid não fica exageradamente grande com poucos itens.
   */
  getAdaptiveMinHeight(): string {
    const leftCount = (this.available?.sift?.length as number) || 0;
    const rightCount = (this.confirmed?.sift?.length as number) || 0;
    const maxCount = Math.max(leftCount, rightCount);

    // Altura "ideal" em função do número de linhas (aprox. 44px por linha + padding)
    const rowHeightPx = 44;
    const baseMinPx = 120; // mínimo para não ficar minúsculo quando há 1–2 itens
    const desiredPx = Math.max(baseMinPx, maxCount * rowHeightPx + 32);

    // Altura máxima vinda do componente (this.height pode ser string "360px" ou número)
    let maxPx = 360;
    if (typeof this.height === "number") {
      maxPx = this.height;
    } else if (typeof this.height === "string") {
      const parsed = parseInt(this.height, 10);
      if (!isNaN(parsed)) {
        maxPx = parsed;
      }
    }

    const finalPx = Math.min(desiredPx, maxPx);
    return `${finalPx}px`;
  }
}
